
    import { RouterLink } from 'vue-router'
    import { defineComponent } from 'vue'
    import type { BreadcrumbItem } from '../../../types';
    import ModalBack from '@/apps/shared/components/modalBack.vue';
    export default defineComponent({
        name: 'XBreadcrumb',
        components: {
            RouterLink,
            ModalBack
        },
        busEvents: {
            updateBreadcrumb(newBreadcrumb: { oldText: string, newText: string }) {
                const breadcrumb = this.localItems.find(item => item.text === newBreadcrumb.oldText);
                if (breadcrumb) {
                    breadcrumb.text = newBreadcrumb.newText;
                }
            },
        },
        data() {
            return {
                localItems: [] as Array<BreadcrumbItem>,
                showModal: false,
                redirectPath: null as string | null,
            }
        },
        mounted() {
            this.localItems = this.getImplicitItems()
        },
        methods: {
            getImplicitItems(): Array<BreadcrumbItem> {
                const items: Array<BreadcrumbItem> = [];

                const fullPath = this.$route.fullPath;
                const paths = fullPath.split('/');
                const firstSegment = paths[1] ? `/${paths[1]}` : '/';
                const inicioPath = firstSegment === '//' ? '/' : firstSegment;

                items.push({
                    text: 'Inicio',
                    path: inicioPath
                });

                const matchedRoute = this.$route.matched?.[this.$route.matched.length - 1];

                if (matchedRoute && matchedRoute.meta?.title) {
                    const title = matchedRoute.meta.title(matchedRoute);
                    // Si el título no es 'Inicio', agregarlo
                    if (title !== 'Inicio') {
                        items.push({ text: title, path: matchedRoute.path });
                    }
                }

                return items;
            },
            onBreadcrumbClick(item: BreadcrumbItem, index: number) {
                if (index === this.localItems.length - 1
                    || item.path === this.$route.path)
                    return;

                this.redirectPath = item.path;
                this.showModal = true;
            },
            goFirstStep() {
                this.showModal = false;
                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                this.redirectPath = rutaAlternativa || this.redirectPath;
                if (this.redirectPath && this.redirectPath !== this.$route.path) {
                    this.$router.push(this.redirectPath);
                }
            },
            continueQuote() {
                this.showModal = false;
                this.redirectPath = null;
            },
        }
    })
